import React from "react";
import { classNames } from "../../../util/strings";

type PLabelProps = {
  label: string;
  htmlFor?: string;
  required?: boolean;
  error?: boolean;
};

const PLabelComponent = (props: PLabelProps) => {
  const { label, required, htmlFor, error } = props;

  return (
    <label
      htmlFor={htmlFor}
      className={classNames(
        "block mb-2 text-sm leading-3 font-semibold text-left",
        error ? "text-danger" : null,
      )}
    >
      {label}
      {required ? <span className="text-primary font-bold">*</span> : null}
    </label>
  );
};

PLabelComponent.defaultProps = {
  htmlFor: undefined,
  required: false,
  error: false,
};

export default PLabelComponent;
